import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DataTable, { MUIDataTableOptions } from "mui-datatables";
import * as Dati from "../../../Dati";
import { _TableLoader } from "../../components/";
import { GetPoliciesListColumns } from "./PoliciesListColumns";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative",
        "& .expired span, & .expiring span": {
            display: "inline-block",
            padding: "4px",
            borderRadius: "16px"
        },
        "& .expired span": {
            background: palette.error.main
        },
        "& .expiring span": {
            background: palette.warning.light
        }
    }
}));

interface IPoliciesListTableProps {
    Data: Dati.CRisAPIPaginePolizzaGenerale | undefined;
    IsLoading: boolean;
    Options: MUIDataTableOptions;
}

export const _PoliciesListTable: React.FC<IPoliciesListTableProps> = React.memo(({ Data, IsLoading, Options }) => {
    const classes = useStyles();

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable title="" data={Data?.Dati || []} columns={GetPoliciesListColumns(Data?.Dati)} options={Options} />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/PoliciesList/PoliciesListTable.tsx